import {createAction} from 'redux-api-middleware';
import {getHeaders} from '@core/actions/xhrRequest';

export const COUPON_CHECK_INIT = 'COUPON_CHECK_INIT';
export const COUPON_CHECK_SUCCESS = 'COUPON_CHECK_SUCCESS';
export const COUPON_CHECK_FAILURE = 'COUPON_CHECK_FAILURE';
export const COUPON_CLEAR = 'COUPON_CLEAR';

export const COUPON_STATUS_PENDING = 'PENDING';
export const COUPON_STATUS_SUCCESS = 'SUCCESS';
export const COUPON_STATUS_FAILURE = 'FAILURE';

// Coupon types as returned by upstream `customer-api/coupon/check`.
// Same convention used by the v5/essay form so the BFF response shape
// is shared across themes.
export const COUPON_TYPE_PERCENT = 1;
export const COUPON_TYPE_PRICE = 2;

export const checkCoupon = (code) => createAction({
    types: [
        {
            type: COUPON_CHECK_INIT,
            payload: {code},
        },
        {
            type: COUPON_CHECK_SUCCESS,
            payload: (action, state, res) => res.json().then(json => ({
                code,
                status: json && json.isValid ? COUPON_STATUS_SUCCESS : COUPON_STATUS_FAILURE,
                data: json || null,
            })),
        },
        {
            type: COUPON_CHECK_FAILURE,
            payload: {code},
        },
    ],
    endpoint: '/api/coupon/check',
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify({code}),
    credentials: 'include',
});

export const clearCoupon = () => ({type: COUPON_CLEAR});
